module.exports = __webpack_public_path__ + "static/media/box-yellow.9d87372b.svg";